import Model, { attr, belongsTo } from '@warp-drive/legacy/model';

import {
  buildValidations,
  validator,
} from 'umg-ember-backend/utils/validations';

const Validations = buildValidations({
  category: [validator('belongs-to'), validator('presence', true)],
  partnerType: [validator('presence', true)],
});

export default class CustomShopModel extends Model.extend(Validations) {
  @attr('string') url;
  @attr('string') partnerType;

  // CMS fields
  @attr('number') position;

  // Meta fields
  @attr cmsCreated;
  @attr cmsDeleted;
  @attr cmsLocktime;
  @attr cmsModified;
  @attr() cmsHistory;
  @belongsTo('user', { async: true, inverse: null }) cmsOwnerId;
  @belongsTo('user', { async: true, inverse: null }) cmsCreatorId;
  @belongsTo('user', { async: true, inverse: null }) cmsLockerId;
  @belongsTo('user', { async: true, inverse: null }) cmsModifierId;

  // Relations
  @belongsTo('category', { async: true, inverse: null }) category;
  @belongsTo('product', { async: true, inverse: 'customShops' }) product;
}
